// extracted by mini-css-extract-plugin
export var container = "RejectNote-module--container--87kQV";
export var textarea = "RejectNote-module--textarea--KT5pI";
export var title = "RejectNote-module--title--wqyfG";